import { Draft } from '@reduxjs/toolkit';

import { IManufacturerData } from '../../index';

function createSuccess(draft: Draft<IManufacturerData>) {
  draft.create.config.isLoading = false;
}

export default createSuccess;
